import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { WorkdayProjectDatasetDto, DatasetlistDto } from "app/ApiClient";

export interface WorkdayProjectDatasetState {
  addWorkdayProjectDatasetLoadingState: LoadingState;
  isWorkdayProjectDatasetExists?: boolean;
  workdayProjectId?: number;
  createdProject?: WorkdayProjectDatasetDto;
  isAddNewWorkdayDatasetDialog?: boolean;
  loading: LoadingState;
  datasetslist:DatasetlistDto[];
  isExistProject?: boolean;

}

export const initialWorkdayProjectDatasetState: WorkdayProjectDatasetState = {
  addWorkdayProjectDatasetLoadingState: LoadingState.idle,
  isWorkdayProjectDatasetExists: false,
  workdayProjectId: undefined,
  isAddNewWorkdayDatasetDialog: false,
  loading: LoadingState.idle,
  isExistProject:false,
  datasetslist: []
};
